import * as api from "@/api/williams/contractors";
import { Contractor } from "@/api/williams/contractors";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function useDeleteContractor() {
  const queryClient = useQueryClient();

  return useMutation(async (contractor: Contractor) => {
    await api.deleteContractor(contractor.id);

    queryClient.removeQueries(queryKeys.contractor.single(contractor.id));
    queryClient.invalidateQueries(queryKeys.contractor.list());
  });
}
